import axios from 'axios';
import { API_URL } from '../../config/system/systemConfig';
import { ResponseSuccessModel } from '../../models/system/responseSuccessModel';
import authHeader from '../../utils/authHeaderUtils';
import { handleAxiosError } from '../../utils/errorUtils';

class StaticDataApi {

    async getCompanySizes() {
        try {
            const response = await axios.get(`${API_URL}/api/static-data/company-sizes`,
                {
                    headers: authHeader(),
                });

            return response.data as ResponseSuccessModel;
        }
        catch (error) {
            return handleAxiosError(error);
        }
    }
    
}

const staticDataApi = new StaticDataApi();
export default staticDataApi;
